import { api } from "./api";

export const pushSupported = () =>
  typeof window !== "undefined" && "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

export const isIOS = () =>
  typeof navigator !== "undefined" && /iP(hone|ad|od)/.test(navigator.userAgent) && !window.MSStream;

export const isStandalone = () =>
  (typeof window !== "undefined" && window.matchMedia && window.matchMedia("(display-mode: standalone)").matches) ||
  (typeof navigator !== "undefined" && navigator.standalone === true);

const urlB64ToUint8Array = (base64String) => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
};

const getReg = async () => {
  await navigator.serviceWorker.register("/sw.js").catch(() => {});
  return navigator.serviceWorker.ready;
};

export const getSubscription = async () => {
  if (!pushSupported()) return null;
  const reg = await getReg();
  return reg.pushManager.getSubscription();
};

export const enablePush = async () => {
  if (!pushSupported()) throw new Error("unsupported");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("denied");
  const { data } = await api.get("/push/vapid-public");
  if (!data.key) throw new Error("no-key");
  const reg = await getReg();
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlB64ToUint8Array(data.key),
    });
  }
  await api.post("/push/subscribe", { subscription: sub.toJSON() });
  return true;
};

export const disablePush = async () => {
  const sub = await getSubscription();
  if (sub) {
    try { await api.post("/push/unsubscribe", { endpoint: sub.endpoint }); } catch (_) {}
    await sub.unsubscribe().catch(() => {});
  }
  return true;
};

export const sendTestPush = () => api.post("/push/test");
export const getPrefs = () => api.get("/push/prefs");
export const savePrefs = (prefs) => api.post("/push/prefs", prefs);

// App icon badge "bubble" (Badging API) — works on installed PWAs: Android (Chrome/Edge)
// and iOS 16.4+ home-screen apps. No-op where unsupported.
export const setAppBadge = async (count) => {
  try {
    if (typeof navigator === "undefined") return;
    if (count > 0 && navigator.setAppBadge) await navigator.setAppBadge(count);
    else if (navigator.clearAppBadge) await navigator.clearAppBadge();
  } catch (_) { /* unsupported / not installed */ }
};
